'use client';

import { type ComponentProps, useEffect, useRef, useState } from 'react';
import { VideoThumbnail } from '@/app_components/Video/Video';

export const VideoThumbnailStn = (props: ComponentProps<typeof VideoThumbnail>) => {
  const ref = useRef<HTMLSpanElement | null>(null);
  const [useExtraLargeImage, setUseExtraLargeImage] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }

    const { width } = el.getBoundingClientRect();
    const stnLargeImageWidth = 190;
    setUseExtraLargeImage(width > stnLargeImageWidth);
  }, []);

  return (
    <VideoThumbnail
      {...props}
      // Avoiding ref keyword
      containerRef={ref}
      src={useExtraLargeImage ? props.src.replace('/LG/', '/XL/') : props.src}
    />
  );
};
